import * as React from "react";
const SvgElectricalPlug = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.777 3.757a.75.75 0 0 1 1.024.275l2.125 3.68 3.897-2.25-2.125-3.68a.75.75 0 0 1 1.3-.75l2.125 3.68 1.082-.625a.75.75 0 0 1 .75 1.3l-.216.124.374.65 1.339 2.318c1.153 1.997.566 4.49-1.206 5.911l.416.72.006.01c.157.283.308.374.437.4.15.03.467.013 1.024-.328.725-.444 1.458-.596 2.12-.45.663.146 1.17.573 1.45 1.115.575 1.116.155 2.592-1.335 3.292-.58.273-.734.523-.775.648-.04.122-.035.309.124.597l.187.324a.75.75 0 0 1-1.3.75l-.19-.33-.006-.01c-.277-.5-.46-1.138-.239-1.804.22-.663.779-1.164 1.561-1.532.78-.367.796-.945.64-1.248a.637.637 0 0 0-.439-.337c-.202-.044-.542-.026-1.014.264-.722.442-1.435.656-2.107.519-.691-.14-1.154-.612-1.446-1.135l-.413-.715c-2.116.824-4.57.086-5.722-1.911L5.886 10.91l-.375-.65-.216.125a.75.75 0 0 1-.75-1.299l1.082-.625-2.125-3.68a.75.75 0 0 1 .275-1.025Zm3.408 6.404-.375-.65 5.63-3.25.375.65 1.338 2.318c.833 1.443.304 3.373-1.278 4.287-1.582.913-3.518.405-4.351-1.037L7.185 10.16Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgElectricalPlug;
